import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { useEffect, useState } from 'react';
// import randomColor from 'randomcolor'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { useDispatch } from 'react-redux';
import { loadMonth } from '../../redux/api_calls/apiCalls';
import { useSelector } from 'react-redux';
import { Box } from '@chakra-ui/layout';
import { Progress } from '@chakra-ui/progress';
import { useDisclosure } from '@chakra-ui/hooks';
import EditCalendarSlotModal from '../common/EditCalendarSlotModal';
import { formatCalendarSlotDate } from '../../redux/actions/actions';
import { IconButton } from '@chakra-ui/react';
import { selectedMenu } from "../../redux/actions/actions";

export default function CalendarSchedule() {
    // const [leaves, setLeaves] = useState([])
    const { monthData, isLoading } = useSelector(state => state.calendarMonthState)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const [calendarData, setCalendarData] = useState()
    const [selectedMonth, setSelectedMonth] = useState(null)
    const [selectedSlot, setSelectedSlot] = useState('')
    const { isOpen, onOpen, onClose } = useDisclosure()

    const localizer = momentLocalizer(moment)
    const dispatch = useDispatch()



    const populateCalendar = () => {
        let newList = []
        monthData.forEach(day => {
            let start_at = new Date(day.date)
            let day1 = new Date(day.date).getDay();
            newList.push({ id: day.id, start: start_at, color: (day.status === '2') ? '#f9ebdf':day.status === '3' ? '#e0e0d1':day1=== 0 ? '#e0e0d1':day1=== 6 ? '#e0e0d1':"#fff", end: start_at, type: 'day', allDay: 'true' })
        })
        setCalendarData(newList)
    }

    const getSelectedSlotValue = (date) => {
        let day = Number(date.split('-')[2]) - 1
        return monthData[day].status
    }

    const getSelectedSlotID = (date) => {
        let day = Number(date.split('-')[2]) - 1
        return monthData[day].id
    }

    useEffect(() => {
        if (monthData.length) {
            console.log(monthData)
            populateCalendar()
        }
        // eslint-disable-next-line
    }, [monthData])

    const getCurrentMonth = () => {
        let date = new Date(Date.now())
        let month = Number(date.getMonth()) + 1
        dispatch(loadMonth(date.getFullYear(), month))
    }

    useEffect(() => {
        dispatch(selectedMenu(4))
        setSelectedMonth(new Date())
        getCurrentMonth()
        // eslint-disable-next-line
    }, [])

    const selectSlotHandler = (slot) => {
        setSelectedSlot(formatCalendarSlotDate(slot.start))
        onOpen()
        // console.log(slot)
    }

    const selectEventHandler = (event) => {
        setSelectedSlot(formatCalendarSlotDate(event.start))
        onOpen()
        console.log(event)
    }

    const navigationHandler = (event) => {
        let navigatedMonth = new Date(event)
        let month = Number(navigatedMonth.getMonth()) + 1
        dispatch(loadMonth(navigatedMonth.getFullYear(), month))
        setSelectedMonth(navigatedMonth)
    }


    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
            <Box
                width={['90%', '85%', '80%', '80%']}
                flexDirection='column'
                justifyContent='center'
                alignItems='center'
                mt='1.5rem'
                
            >
                {
                    isLoading ?
                        <Progress isIndeterminate size='xs' width='100%' /> :
                        <Calendar
                            localizer={localizer}
                            views={['month']}
                            events={calendarData}
                            selectable={true}
                            startAccessor="start"
                            endAccessor="end"
                            defaultDate={selectedMonth}
                            eventPropGetter={event => {
                                const eventData = calendarData.find(ot => ot.id === event.id);
                                const backgroundColor = eventData && eventData.color;
                                return { style: { backgroundColor, color: 'black', fontSize: '0.9rem' } };
                            }}
                            dayPropGetter = {date => {
                                console.log(calendarData)
                                const eventData = calendarData.find(ot => Date.parse(ot.start.toString().substring(0,15)) === Date.parse(date.toString().substring(0,15)))
                                // console.log(date, eventData)
                                const backgroundColor = eventData && eventData.color
                                return {style :{ backgroundColor, fontFamily: 'Mulish, sans-serif'} }
                        }}
                            style={{ minHeight: '100vh', width: '98%', fontFamily: 'Mulish, sans-serif',marginTop:'1.5rem',marginLeft:'0.5rem',marginRight:'1.5rem',marginBottom:'1.5rem' }}
                            
                            onNavigate={navigationHandler}
                            onSelectSlot={selectSlotHandler}
                            onSelectEvent = {selectEventHandler}
                        />
                }
            </Box>
            {
                selectedSlot.length > 0 &&
                <EditCalendarSlotModal isOpen={isOpen} onClose={onClose} title={selectedSlot} currentValue={getSelectedSlotValue(selectedSlot)} date={selectedSlot} id={getSelectedSlotID(selectedSlot)} />
            }
            <Box
        width={['90%', '85%', '80%', '80%']}
        d='flex'
        style={{ marginTop: '21px', marginBottom: '14px' }}
      >
        <IconButton
          isRound
          size='xs'
          backgroundColor='rgba(65, 153, 225, 0.1)'
          style={{
            marginRight: '23px',
            marginLeft: '33px',
            border: '1px solid #4199E1',
          }}
        />
        Weekend
        <IconButton
          isRound
          size='xs'
          backgroundColor='#F9EBDF'
          style={{
            marginRight: '23px',
            marginLeft: '33px',
            border: '1px solid #FF7201',
          }}
        />
        Holiday
        <IconButton
          isRound
          size='xs'
          backgroundColor='white'
          style={{
            marginRight: '23px',
            marginLeft: '33px',
            border: '1px solid #3FC429',
          }}
        />
        Working day
      </Box>
        </Box>
    )
}
